module.exports = __webpack_public_path__ + "static/img/icon_time.781c9e03.svg";